(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/account-selector/assets/javascripts/constants.js') >= 0) return;  svs.modules.push('/components/numbergames/account-selector/assets/javascripts/constants.js');

'use strict';

const events = {
  FETCHED: 'FETCHED',
  ACTIVE_ACCOUNT_CHANGED: 'ACTIVE_ACCOUNT_CHANGED',
  ACCOUNT_BALANCE_UPDATED: 'ACCOUNT_BALANCE_UPDATED'
};
const errors = {
  INVALID_ARGUMENTS: 'INVALID_ARGUMENTS',
  INVALID_ACCOUNT_SELECTED: 'INVALID_ACCOUNT_SELECTED',
  UNKNOWN: 'UNKNOWN'
};
const errorMessages = {
  [errors.INVALID_ARGUMENTS]: 'Missing or invalid arguments',
  [errors.INVALID_ACCOUNT_SELECTED]: 'The selected account does not exist or is invalid',
  [errors.UNKNOWN]: 'Unknown error'
};
svs.numbergames.accountSelector.constants = {
  events,
  errors,
  errorMessages
};

 })(window);